module.exports = __webpack_public_path__ + "img/tiktok-logo.dbb2c961.svg";